import {
    loginUser,
    fetchUserDetails,
    getInstalationsDropdown
} from "@/api/authentication";
import router from '@/router'
import { PAGES } from "@/enums/pages";
import { profilesMapping } from "@/enums/profiles/profiles";
import i18n from "@/i18n";
import Vue from "vue";

const locales = [
    {
        key: 1,
        value: "PT",
        selected: true,
    },
    {
        key: 2,
        value: "ES",
        selected: false,
    },
];

const launchErrorToast = (msg) => {
    Vue.$toast.open({
        message: msg,
        dismissible: true,
        type: "error",
    });
};

const initialState = {
    errorMessage: "",
    hasErrorMessage: false,
    token: "",
    userDetails: {},
    instalation: "",
    instalationsDropdown: [],
    locale: localStorage.getItem("locale") ?? "pt_pt",
    localesDropdown: locales,
    rawInstalations: [],
    userEntityId: localStorage.getItem("instalationId"),
    instanceId: localStorage.getItem("instanceId"),
    instancesDropdown: [],
    instancesDropdownV2: [
        {
            value: -1,
            text: i18n.t("dropdownSelection"),
            disabled: true,
        }
    ],
};

const state = {
    ...initialState
};

const getters = {
    getErrorMessage: (state) => state.errorMessage,
    hasErrorMessage: (state) => state.hasErrorMessage,
    getToken: (state) => state.token,
    getUserDetails: (state) => state.userDetails,
    getUserName: (state) => state.userDetails?.NAME,
    getInstalations: (state) => state.instalationsDropdown,
    getLocale: (state) => state.locale,
    getLocaleDropdown: (state) => state.localesDropdown,
    getUserId: (state) => state.userDetails?.ID,
    getUserInstalationId: (state) => state.instalationsDropdown.find((item) => item.selected)?.value,
    getUserEmail: (state) => state.userDetails.EMAIL,
    getRawInstalations: (state) => state.rawInstalations,
    getIdProfile: (state) => state.userDetails.ID_PROFILE,
    getProfileLabel: (state) => profilesMapping[state.userDetails.ID_PROFILE],
    getUserEntityId: (state) => state.userEntityId,
    getInstalationSelected: (state) => state.instalationsDropdown.find((item) => item.selected),
    getInstances: (state) => state.instancesDropdown,
    getInstancesV2: (state) => state.instancesDropdownV2,
    getUserInstanceId: (state) => state.instanceId,
    getInstanceSelected: (state) => state.instancesDropdownV2.find((item) => item.selected),
};

const mutations = {
    setErrorMessage(state, errorMessage) {
        state.errorMessage = errorMessage;
    },
    setHasErrorMessage(state, hasErrorMessage) {
        state.hasErrorMessage = hasErrorMessage;
    },
    setToken(state, token) {
        state.token = token;
    },
    setUserDetails(state, userDetails) {
        state.userDetails = userDetails;
    },
    setActiveInstalationsDropdown(state, instalationsDropdown) {
        state.instalationsDropdown = instalationsDropdown;
    },
    setInstalationsDropdown(state, instalationsDropdown) {
        let newArrayOfObjDropdown = instalationsDropdown.map(({
            ID: value,
            NAME: text,
            STREET: address
        }) => ({
            value,
            text,
            address
        }));

        //HAMMER TIME
        //Preselected Instalation - 246
        if(newArrayOfObjDropdown[0])
            newArrayOfObjDropdown[0].selected = true;

        state.instalationsDropdown = newArrayOfObjDropdown;
    },
    setInstalationsDropdownv2(state, instalationsDropdown) {
        state.instalationsDropdown = instalationsDropdown;
    },
    setLocale(state, locale) {
        state.locale = locale;
    },
    setLocalesDropdown(state, localesDropdown) {
        state.localesDropdown = localesDropdown;
    },
    setInstalationsRaw(state, rawInstalations) {
        state.rawInstalations = rawInstalations;
    },
    setUserEntityId(state, userEntityId) {
        state.userEntityId = userEntityId;
        localStorage.setItem("instalationId", userEntityId);
    },
    setUserInstanceId(state, instanceId) {
        state.instanceId = instanceId;
        localStorage.setItem("instanceId", instanceId);
    },
    setInstancesDropdown(state, instances) {
        let newArrayOfObjDropdown = instances.map(({
            id: id,
            id: value,
            nameEx: label,
            nameEx: text,
            status: status
        }) => ({
            id,
            value,
            label,
            text,
            status
        }));

        newArrayOfObjDropdown[0].selected = true;

        state.instancesDropdown = newArrayOfObjDropdown;
    },
    setInstancesDropdownV2(state, instances) {
        let newArrayOfObjDropdown = instances.map(({
            id: id,
            id: value,
            nameEx: label,
            nameEx: text,
            status: status,
            country: country
        }) => ({
            id,
            value,
            label,
            text,
            status,
            country
        }));
        
        newArrayOfObjDropdown = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...newArrayOfObjDropdown,
        ];

        state.instancesDropdownV2 = newArrayOfObjDropdown;
    },
};

const actions = {
    async storeLogin({ commit }, userObj) {
        try {
            const response = await loginUser(userObj);
            const token = response?.data?.data?.token;

            if (userObj.providerId === 2 && (response?.response?.data?.statusCode === 403 || response?.response?.data?.statusCode === 401)) {

                launchErrorToast(i18n.t('pages.loginPage.notAuthorized'));
                return;
            }

            if (!response?.data && response?.response?.data?.statusCode === 401) {
                commit("setErrorMessage", i18n.t('pages.loginPage.notAuthorized'));
                commit("setHasErrorMessage", true);

                return;
            }

            if (!response?.data && response?.response?.data?.statusCode === 412) {
                commit("setErrorMessage", i18n.t('pages.loginPage.emptyInstalations'));
                commit("setHasErrorMessage", true);

                return;
            }

            if (!response?.data && response?.response?.data?.statusCode !== 200) {
                commit("setErrorMessage", i18n.t("pages.loginPage.errorLogin"));
                commit("setHasErrorMessage", true);

                return;
            }

            commit("setHasErrorMessage", false);

            commit("setToken", token);
            localStorage.setItem("token", token);

            const resp = await fetchUserDetails();
            const { instances } = resp?.data?.data;

            if(instances && instances?.length > 1) {
                router.push({
                    name: PAGES.INSTANCE_CHOOSE,
                });
            } else {
                commit("setUserInstanceId", instances[0]?.id);
                router.push({
                    name: PAGES.SIMULATOR,
                });
            }
        } catch (error) {
            commit("setErrorMessage", i18n.t("pages.loginPage.errorLogin"));
            commit("setHasErrorMessage", true);

        }

    },
    async getUserDetails({ commit }) {
        try {
            const response = await fetchUserDetails();
            commit("setUserDetails", response?.data?.data);

            commit("setInstancesDropdown", response?.data?.data?.instances);
            commit("setInstancesDropdownV2", response?.data?.data?.instances);
        } catch (error) {
            console.log(error);
        }
    },
    async fetchInstalationsDropdown({ getters, commit }) {
        try {
            const idInstance = getters.getUserInstanceId || -1;
            const response = await getInstalationsDropdown(idInstance);
            const entities = response?.data?.data;
            commit("setInstalationsDropdown", entities);
            commit("setInstalationsRaw", entities);
        } catch (error) {
            console.log(error);
        }

    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};